export default "__VITE_ASSET__BuwRx0wv__"